import { render, staticRenderFns } from "./UploadImageButton.vue?vue&type=template&id=3d89df54&"
import script from "./UploadImageButton.vue?vue&type=script&lang=js&"
export * from "./UploadImageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports